import React, { useState } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import RegistrationForm from '../components/RegistrationForm';

const PageContainer = styled.div`
  min-height: 100vh;
  padding: 120px 20px 60px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url('/path-to-your-background-pattern.svg');
    background-size: cover;
    opacity: 0.05;
    z-index: 0;
  }
  
  @media (max-width: 768px) {
    padding: 100px 15px 40px;
  }
`;

const PageTitle = styled.h1`
  font-size: 2.5rem;
  color: var(--text-dark, #1f2937);
  margin-bottom: 40px;
  text-align: center;
  font-weight: 700;
  
  span {
    color: var(--secondary-cyan, #06b6d4);
  }
  
  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 30px;
  }
`;

const SubTitle = styled.p`
  font-size: 1.1rem;
  color: var(--neutral-gray, #6b7280);
  max-width: 600px;
  text-align: center;
  margin-bottom: 30px;
  line-height: 1.6;
  
  @media (max-width: 768px) {
    font-size: 1rem;
    margin-bottom: 25px;
  }
`;

const RegistrationPage: React.FC = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  
  const handleClose = () => {
    setFormSubmitted(true);
    // Redirect to home page after a short delay
    setTimeout(() => {
      window.location.href = '/';
    }, 2000);
  };
  
  return (
    <PageContainer>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <PageTitle>
          IIITD-IC Summer Camp <span>2026</span> Registration
        </PageTitle>
        <SubTitle>
          Join the IIITD-IC Summer Camp 2026 and learn cutting-edge skills in robotics, IoT, AI, drone technology, and aero modeling. Limited seats available!
        </SubTitle>
      </motion.div>
      
      {formSubmitted ? (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          style={{
            background: 'white',
            padding: '30px',
            borderRadius: '15px',
            textAlign: 'center',
            maxWidth: '500px'
          }}
        >
          <h2 style={{ marginBottom: '15px', color: '#333' }}>Thank You!</h2>
          <p style={{ color: '#666' }}>
            Your registration is complete. Redirecting you to the home page...
          </p>
        </motion.div>
      ) : (
        <RegistrationForm onClose={handleClose} />
      )}
    </PageContainer>
  );
};

export default RegistrationPage;
